var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCongrats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 118,
    viewBox: "0 0 59 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6142 81.4984C31.4809 81.5453 31.3618 81.5827 31.2258 81.621C28.742 82.3206 2.00018 89.5098 2 74.7193C1.99981 59.2085 11.9027 47.279 29.132 47.3837L33.2915 47.4091C44.7777 47.4788 52.5611 59.0071 53.9709 66.8471C55.3808 74.6872 54.5755 79.9568 48.5323 80.7624C42.4891 81.5681 31.4102 78.3453 32.8203 75.3237C34.2303 72.3021 47.928 73.1078 48.2134 73.0885C48.4989 73.0692 47.5237 71.6357 46.6624 71.6305C45.801 71.6253 45.0984 72.2695 45.0935 73.0696L44.8708 109.545C44.8625 110.911 43.9332 112.106 42.598 112.397C37.6454 113.475 32.4772 114.031 27.165 113.999C23.4025 113.976 20.0349 113.659 16.5694 113.072C15.1536 112.832 14.1449 111.583 14.1541 110.147L14.3679 76.5657C14.3736 75.6327 13.6815 74.7254 12.6764 74.7193C12.2306 74.7166 11.2663 75.1222 11.2663 76.1294C11.2663 77.1366 26.9786 74.115 32.8203 72.5035C38.6109 70.9061 39.2553 78.8095 31.6142 81.4984Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.429 20.6603C48.3275 31.6951 40.2353 41.2528 29.3542 42.008C18.4732 42.7631 8.40399 34.4268 7.50538 23.3921C6.6068 12.3573 15.2191 2.80276 26.1 2.04754C36.981 1.29231 46.5302 9.62554 47.429 20.6603Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3379 32.6187C22.268 34.8774 25.6259 36.0864 27.0966 36.201C29.0292 36.3515 30.7825 36.201 33.4242 34.2996",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.36464,
    cy: 3.18947,
    rx: 8.36464,
    ry: 3.18947,
    transform: "matrix(0.818689 0.574238 -0.572464 0.81993 32.5967 57.4647)",
    fill: "#F7CF94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 69C42.3827 68.5154 32.9643 64.3168 31.3419 59.7384C31.2726 59.543 30.9524 59.5241 30.8825 59.7192L21.6536 85.4875C21.3193 86.4208 22.4029 87.2235 23.1991 86.6327C32.2904 79.8872 46.5218 69.4627 44.5 69Z",
    fill: "#FFB84E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0372 64.908C43.4306 65.7591 41.2571 66.0732 40.2461 66.1239V66.7319C40.5494 66.7826 41.5654 66.9419 42.9757 66.4279C44.6438 65.8199 44.7924 65.537 44.9471 64.452C45.0987 63.388 44.3047 63.084 44.6438 63.084C44.7954 63.084 45.7053 63.54 46.4635 63.388C46.954 63.2897 47.3734 62.3241 47.525 61.7161L47.0701 61.2601C47.0701 61.2601 47.0701 61.1993 46.4635 62.1721C45.7053 63.388 45.0987 61.8681 44.0372 62.476C42.9757 63.084 44.7954 63.844 44.0372 64.908Z",
    fill: "#FCE9CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9973 59.4171C36.426 58.7468 36.3277 56.5622 36.2249 55.5536L36.5881 55.5053C36.6583 55.8026 36.8872 56.7995 36.7657 58.2416C36.6219 59.9473 36.4725 60.1175 35.8446 60.3574C35.229 60.5926 34.9429 59.8278 34.9875 60.1648C35.0075 60.3154 35.3996 61.1832 35.4085 61.9487C35.4143 62.4438 34.8927 62.9373 34.5494 63.1363L34.2171 62.7205C34.2171 62.7205 34.1808 62.7253 34.6821 62.0453C35.3088 61.1953 34.321 60.7134 34.5445 59.6104C34.768 58.5074 35.4615 60.255 35.9973 59.4171Z",
    fill: "#FCE9CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5529 58.0106C40.9189 57.0627 42.9733 56.1319 43.9548 55.785L43.7897 55.2369C43.4773 55.2816 42.4338 55.4408 41.1851 56.3243C39.7081 57.3693 39.6386 57.6687 39.781 58.6928C39.9207 59.697 40.7849 59.7344 40.4511 59.8354C40.3018 59.8806 39.2822 59.7407 38.5771 60.1036C38.121 60.3384 37.9703 61.3338 37.9862 61.927L38.5579 62.2024C38.5579 62.2024 38.5744 62.2572 38.9073 61.1997C39.3235 59.8777 40.3334 61.067 41.2133 60.2027C42.0932 59.3384 40.0954 59.1956 40.5529 58.0106Z",
    fill: "#FCE9CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.946 56.8309C47.3119 55.8829 49.3664 54.9521 50.3479 54.6052L50.1827 54.0572C49.8704 54.1019 48.8269 54.261 47.5782 55.1445C46.1011 56.1896 46.0316 56.4889 46.1741 57.513C46.3137 58.5172 47.178 58.5546 46.8441 58.6557C46.6949 58.7008 45.6753 58.5609 44.9702 58.9239C44.514 59.1587 44.3634 60.154 44.3792 60.7472L44.9509 61.0227C44.9509 61.0227 44.9674 61.0775 45.3004 60.0199C45.7166 58.698 46.7265 59.8872 47.6064 59.0229C48.4863 58.1586 46.4885 58.0158 46.946 56.8309Z",
    fill: "#FCE9CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8198 57.4597L39.1846 56.3957L40.2461 57.7636L38.4264 58.3716L37.8198 57.4597Z",
    fill: "#FFB84E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9618 58.13L42.7195 56.7284L44.1679 57.0911L42.8404 58.4234L41.9618 58.13Z",
    fill: "#FFB84E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0327 63.8785L40.3975 63.3875L41.459 64.0188L39.6393 64.2994L39.0327 63.8785Z",
    fill: "#FFB84E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9 61.2871L36.7141 62.3028L35.4796 61.5622L37.1761 60.7731L37.9 61.2871Z",
    fill: "#FFB84E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1892 60.7919L44.4894 61.4755L43.727 60.9371L44.7405 60.4207L45.1892 60.7919Z",
    fill: "#FFB84E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8845 61.7189L41.9637 60.332L43.4947 60.5436L41.8004 61.9164L40.8845 61.7189Z",
    fill: "#FFB84E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8118 71.7859C27.1868 72.4449 18.3426 75.3554 13.9675 76.1105C12.6132 78.8563 10.5609 83.8125 13.811 84.142C17.8737 84.5538 26.7805 82.0826 31.1557 78.3758C33.8294 76.1105 30.8429 70.9621 28.8118 71.7859Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6746 68.9567C36.9422 69.637 42.5353 72.4075 45.9479 73.1869C47.0042 76.0213 48.483 80.3 45.9479 80.6401C42.779 81.0653 37.6889 79.8344 33.077 76.2533C30.6022 74.3316 34.0904 68.1064 35.6746 68.9567Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_642",
    x: 0,
    y: 0,
    width: 58.5688,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_642"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_642",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.2a77474f313d2e2d60370b888e81e6dd.svg";
export { ForwardRef as ReactComponent };